define('views/blocks/checkout/ProductCheckoutDialogView',['jquery',
        'views/blocks/checkout/CheckoutDialogView',
        'app',
        'views/pages/ProductPageView',
        'template!blocks/checkout/dialog-product'],
    function (
              $,
              CheckoutDialogView,
              app,
              ProductPageView,
              dialogProductTemplate) {

        var checkoutModel, cartProduct, quantity, remove, isMenu;
        return CheckoutDialogView.extend({
            name:'product',
            events:{
                'click .dialog-product__link':'openProductPage',
                'click .dialog-product__quantifier':'clickQuantifier'
            },
            initialize:function(options){
                var view = this;
                checkoutModel = options.checkoutModel;
                cartProduct = options.cartProduct;
                remove = false;
                quantity = cartProduct.getQuantity();
                isMenu = cartProduct.isMenu();
                view.listenTo(cartProduct,'change',view.render);
                CheckoutDialogView.prototype.initialize.apply(view, arguments);
            },
            getSubmitText:function(){
                return app.t(remove?'Supprimer':(isMenu?'Modifier':'Valider'),'UI');
            },
            getInner:function(){
                return dialogProductTemplate(cartProduct);
            },
            afterIntro:function(){
                // autofocus
                var view = this;
            },
            openProductPage:function(e){
                var options = {
                    id_product:cartProduct.getProduct().id,
                }
                if(e){
                    options.cartProduct = cartProduct;
                }
                app.displayModal(new ProductPageView(options));
            },
            clickQuantifier:function(e){
                var view = this,
                    offset = $(e.currentTarget).is('.q-plus') ? 1 : -1;
                //
                quantity += offset;
                //
                if(isMenu){
                    if(quantity>1){
                        view.close();
                        view.openProductPage(); // nouveau produit
                        return
                    }
                }
                view.updateButtons();
            },
            updateButtons:function(){
                var view = this,
                    plusBtn = view.$('.q-plus'),
                    minusBtn = view.$('.q-minus');;
                remove = quantity<=0;
                minusBtn.attr('disabled',remove);
                plusBtn.attr('disabled',quantity>1 && isMenu);
                view.$('.dialog-product__quantifier__quantity').text(quantity);
                view.$('.dialog-product__price').text(cartProduct.formatPriceQuantity(quantity));
                view.$('.checkout-opc__dialog__submit .btn-classic__base').text(view.getSubmitText());
            },
            submit:function(){
                var view = this, jqxhr,
                    currentQuantity = cartProduct.getQuantity(),
                    cart = app.getCart();
                // TODO
                view.$('.btn-submit').addClass('loading');
                if(quantity-currentQuantity === 0 ){
                    view.close();
                    if(isMenu){
                        view.openProductPage(true); // modification
                    }
                    return;
                }else if(remove){
                    jqxhr = cart.deleteProduct(cartProduct.id)
                }else if(isMenu){
                    view.openProductPage();
                    return;
                }else{
                    jqxhr = cart.updateQuantityProduct(cartProduct.id,quantity-currentQuantity);
                }
                jqxhr.done($.proxy(view.close,view));
                return false;
            }
        });
    });
